import React, { ReactElement } from 'react';

import { BAND_NAME } from 'constant';

import Header from 'components/Header';
import Container from 'components/Container';
import Breadcrumbs from 'components/Breadcrumbs';
import Footer from 'components/Footer';
import WorkInProgress from 'components/WorkInProgress';

import photo from 'assets/photo.jpg';

import {
  Wrapper,
  Main,
  Content,
  SideBar,
  Background
} from './Layout.styles';

export interface LayoutProps {
  children: ReactElement | ReactElement[] | string;
  sidebar?: ReactElement | ReactElement[] | string | null;
  className?: string;
  isSpecialDesign?: boolean;
}

const Layout = ({ children, sidebar = null, isSpecialDesign = false, className = '' }: LayoutProps) => {
  return (
    <div className={className}>
      <Header />
      <WorkInProgress />
      <Breadcrumbs isSpecialDesign={isSpecialDesign} />
      <Wrapper isSpecialDesign={isSpecialDesign}>
        <Container>
          <Main>
            <Content withSidebar={Boolean(sidebar)}>
              {children}
            </Content>
            {
              sidebar ? (
                <SideBar>
                  {sidebar}
                </SideBar>
              ) : null
            }
          </Main>
        </Container>
      </Wrapper>
      <Background><img src={photo} alt={BAND_NAME} /></Background>
      <Footer />
    </div>
  );
};

export default Layout;
